module.exports = __webpack_public_path__ + "img/ennetix-application-detail-page-flows-tab2.443beb67.png";